export default {
  PLATFORM_SELECTION: "platforms",
  SERVICE_SELECTION: "services",
  UPSELL: "trial",
  RECOMMENDED_APPLETS: "applets",
}
